import React from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import parse from "html-react-parser";
const AccountStatusLevelsHeader = ({
  userLevel,
  userNextLevel,
  percentForNextLevel,
  amountForNextLevel,
  userCompleteLevels,
}) => {
  console.log("userLevel",userLevel);
  const { getTextByKey } = useContent();
  return (
    <div className="user-level">
      <div className="level-bar">
        <div id="current-level">
          <div
            className="level complete"
            style={{
              backgroundColor: userLevel && userLevel.colorHex && userLevel.colorHex,
            }}
          >
            {userLevel && userLevel.SVG && parse(userLevel.SVG)}
          </div>
          <div className="level-tooltip">
            <span>{getTextByKey("payment-current-status")}</span>
            <span>
              {userLevel && userLevel.Name &&
                getTextByKey("payment-" + userLevel.Name.toLowerCase())}{" "}
              ({userLevel && userLevel.FeeAmount}% {getTextByKey("payment-fee")}
              )
            </span>
          </div>
        </div>
        <div id="level-progress-bar">
          <div
            id="progress"
            style={{
              width: percentForNextLevel,
              backgroundColor: userLevel && userLevel.colorHex,
            }}
          ></div>
        </div>
        <div id="next-level">
          <div
            className="level"
            style={{
              backgroundColor: userCompleteLevels
                ? userNextLevel && userNextLevel.colorHex
                : "",
            }}
          >
            {userNextLevel && userNextLevel.SVG && parse(userNextLevel.SVG)}
          </div>
          <div className="level-tooltip">
            <span>{getTextByKey("payment-next-status")}</span>
            <span>
              {userNextLevel && userNextLevel.Name &&
                getTextByKey(
                  "payment-" + userNextLevel.Name.toLowerCase()
                )}{" "}
              ({userNextLevel && userNextLevel.FeeAmount}%{" "}
              {getTextByKey("payment-fee")})
            </span>
          </div>
        </div>
      </div>
      <div className="current-levelAndStatus-span">
        <span>{getTextByKey("payment-current-status")}</span>
        <span>
          {" "}
          {userLevel && userLevel.Name &&
            getTextByKey("payment-" + userLevel.Name.toLowerCase())}{" "}
          ({userLevel && userLevel.FeeAmount}% {getTextByKey("payment-fee")})
        </span>
      </div>
      {amountForNextLevel && (
        <div className="to-next-level">
          <span className="amount">
            {amountForNextLevel ? amountForNextLevel : ""}
          </span>
          <span> {getTextByKey("payment-for-next-level")}</span>
        </div>
      )}
    </div>
  );
};

export default AccountStatusLevelsHeader;
